import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    places: [],
    statistics: [],
    single: null,
    phs: [], // phs assigned for this asm
    currentPh: null // selected ph
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    // PH
    'PH_CLIENTS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('CLIENTS_REQUEST');
            let params = payload.search ? {'search' : payload.search } : null;
            let url = '/users/ph/'+ payload.ph_slug +'/clients';
            api({url: url, params: params ? params : null, method: 'GET' })
                .then(resp => {
                    commit('CLIENTS_REQUEST_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('CLIENTS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'PH_CLIENTS_DETAILS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('CLIENTS_REQUEST');
            let url = '/users/ph/'+ payload.ph_slug +'/clients/'+ payload.client_slug +'/details'
            api({url: url, method: 'GET' })
                .then(resp => {
                    commit('CLIENTS_SET_SINGLE', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('CLIENTS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'PH_PLACES_DETAILS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('CLIENTS_REQUEST');
            let url = '/users/ph/'+ payload.ph_slug +'/places/'+ payload.sfa +'/details'
            api({url: url, method: 'GET' })
                .then(resp => {
                    commit('CLIENTS_SET_SINGLE', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('CLIENTS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'PH_STATISTICS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('CLIENTS_REQUEST');
            let url = '/users/ph/'+ payload.ph_slug +'/statistics';
            api({url: url, method: 'GET' })
                .then(resp => {
                    commit('PH_STATISTICS_REQUEST_SUCCESS', resp.data.data.statistics);
                    resolve(resp)
                })
                .catch(err => {
                    commit('CLIENTS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'PH_REPORT_CONTRACTS_REQUEST': ({commit, dispatch}, payload) => {
        return new Promise((resolve, reject) => {
            commit('CLIENTS_REQUEST');
            let url = '/users/ph/download/reports/contracts';
            api({url: url, method: 'GET'})
                .then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    commit('CLIENTS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },

    // ASM
    'ASM_CLIENTS_REQUEST': ({commit, dispatch}, value) => {
        return new Promise((resolve, reject) => {
            commit('CLIENTS_REQUEST');
            let url = '/users/asm/representatives';
            let params = value ? {'search' : value } : null;
            api({url: url, params: params ? params : null, method: 'GET' })
                .then(resp => {
                    commit('ASM_CLIENTS_REQUEST_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('CLIENTS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
};

// ----------------------------- o

const mutations = {
    'CLIENTS_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'CLIENTS_REQUEST_SUCCESS': (state, resp) => {
        state.places = resp ? resp : [];
        state.loading = false;
    },
    'PH_STATISTICS_REQUEST_SUCCESS': (state, resp) => {
        state.statistics = resp ? resp : [];
        state.loading = false;
    },
    'ASM_CLIENTS_REQUEST_SUCCESS': (state, resp) => {
        state.phs = resp ? resp : [];
        state.loading = false;
    },
    'ASM_SET_CURRENT_PH': (state, slug) => {
        state.currentPh = slug;
    },
    'CLIENTS_SET_SINGLE': (state, data) => {
        state.single = data;
        state.loading = false;
    },
    'CLIENTS_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
    'CLIENTS_SET_LOYALTY_RESULTS' : (state, data) => {
        state.single.loyalty_program.results = data.results
        state.single.loyalty_program.vouchers = data.vouchers
    }
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
